import { Component } from '@angular/core';
import { PosterCardComponent } from "../../../poster-card/poster-card.component";
import { PageService } from '../../../../services/Page/page.service';
import { AuthService } from '../../../../services/Auth/auth.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-wish-list',
    imports: [
        CommonModule,
        PosterCardComponent,
        RouterModule
    ],
    templateUrl: './wish-list.component.html',
    styleUrl: './wish-list.component.scss'
})
export class WishListComponent {

    constructor(
        public pageService: PageService,
        public authService: AuthService
    ) {

    }

    ngOnInit() {
        console.log(this.authService.profile?.wishListMovies)
    }

    isEmpty() {
        return this.authService.profile?.wishListMovies.length == 0
    }
}
